import { Component, OnInit, ViewChild } from '@angular/core';
import { UserProfile } from 'src/app/Models/user-profile';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { SchoolType } from 'src/app/Models/School/school-type';
import { Principal } from 'src/app/Models/Principal/principal';
import { PrincipalService } from 'src/app/Services/Princiapl/principal.service';

import { FormControl, FormGroup, Validators } from '@angular/forms';
import { School } from 'src/app/Models/School/school';
import { UserService } from 'src/app/Services/user.service';

@Component({
  selector: 'app-principal-info',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit {
  private apiCall = '';
  schoolList : School[];
  schoolTypeList: SchoolType[];
  currentUserInfo: UserProfile;
  datasource;
  principalInfo: Principal;
  principalList;
  numberOfPrincipals: number;
  ///principalList;
  addPrincipalForm = new FormGroup({
    SchoolType: new FormControl('0', Validators.required),
    OrgUnit: new FormControl('0', Validators.required),
    Type : new FormControl('', Validators.required),
    Personnel_Number : new FormControl(),
    Name: new FormControl(),
  });
  isDisabled:boolean = true;
  newPrincipal:any=null;
  displayedColumns: string[] = ["Principal", "School", "SchoolType", "Status", "action"];
  selectedSchoolType = this.addPrincipalForm.value.SchoolType;
  selectedSchoolTypeName: string;
  selectedSchool = this.addPrincipalForm.value.OrgUnit;
  //filterType: MatTableFilter;

  @ViewChild(MatPaginator, {static: false})
  set paginator(value: MatPaginator) {
    if (this.datasource){
      this.datasource.paginator = value;
    }
  }

  @ViewChild(MatSort, {static: false})
  set sort(value: MatSort) {
    if (this.datasource){
      this.datasource.sort = value;
    }
  }
  constructor(private principalService: PrincipalService
                      , private userService: UserService) {
    //this.schoolType = new SchoolType();
   }

  ngOnInit(): void {
    // this.principalService.getSchoolTypeUserPrincipalInfo(this.apiCall);
    // this.schoolTypeList = this.principalService.schoolTypeList;
    // this.schoolList = this.principalService.schoolList;
    // this.currentUserInfo = this.principalService.currentUserInfo;
    // this.principalList = this.principalService.principalList;
    this.apiCall = "/" + this.userService.userPNumber + '/0';
    this.principalList = null;
    this.principalService.getSchoolTypeUserPrincipalInfo(this.apiCall).subscribe(
      data => {
        this.currentUserInfo = data['Table'];
        this.schoolTypeList = data['Table1'];
        this.schoolList = data['Table2'];
        this.principalList = data['Table3'];

        this.principalService.schoolTypeList = this.schoolTypeList;
        this.principalService.schoolList = this.schoolList;
        this.principalService.currentUserInfo = this.currentUserInfo;
        this.principalService.principalList = this.principalList;

        //this.prepareMatTableDatasource();
        this.datasource = new MatTableDataSource(this.principalList);
        this.datasource.sort = this.sort;
        this.datasource.paginator = this.paginator;
        //this.filterType = MatTableFilter.ANYWHERE;
        this.datasource.filterPredicate = function (record,filter) {
          return record.Principal.toLocaleLowerCase() == filter.toLocaleLowerCase();;
        }
      }
    );
    //this.principalList.sort = this.sort;
  }

  filterSchoolBySchoolType() {
    this.selectedSchoolType = this.addPrincipalForm.value.SchoolType;
    if (this.selectedSchoolType !== null && this.selectedSchoolType !== '0') {
      var selectedItem = this.schoolTypeList.filter(item => item.SchoolType == this.selectedSchoolType);
      this.selectedSchoolTypeName = selectedItem[0].Description!;
      this.schoolList = this.principalService.schoolList.filter(item => item.SchoolType == this.selectedSchoolType)
    }
    else if (this.selectedSchoolType == '0') {
      this.selectedSchoolTypeName = '';
      this.schoolList = this.principalService.schoolList;
    }
    this.filterPrincipalBySchool();
  }

  filterPrincipalBySchool() {
    this.selectedSchool = this.addPrincipalForm.value.OrgUnit;
    if (this.selectedSchoolType !== '0' && this.selectedSchool !== '0') {
      this.principalList = this.principalService.principalList.filter(item => item.OrgUnit == this.selectedSchool && item.SchoolType == this.selectedSchoolType);
    }
    else if (this.selectedSchoolType !== '0') {
      this.principalList = this.principalService.principalList.filter(item => item.SchoolType == this.selectedSchoolType);
    }
    else if (this.selectedSchool !== '0') {
      this.principalList = this.principalService.principalList.filter(item => item.OrgUnit == this.selectedSchool);
    }
    this.prepareMatTableDatasource();
  }

  private prepareMatTableDatasource() {
    //this.principalList.sort = this.sort;
    //this.principalList.paginator = this.paginator;
    //this.numberOfPrincipals = this.principalList.length;
    //this.principalList.paginator = this.paginator;
    this.datasource = new MatTableDataSource(this.principalList);
    if (this.paginator === undefined) {
      console.log('paginator is undefined');
    }
    this.datasource.sort = this.sort;
    this.datasource.paginator = this.paginator;
    //this.filterType = MatTableFilter.ANYWHERE;
    // this.datasource.filterPredicate = function (record,filter) {
    //   return record.Principal.toLocaleLowerCase() == filter.toLocaleLowerCase();;
    // }
  }

  addNewPrincipal() {

  }

}
